export const HOST = `${process.env.REACT_APP_GATEWAY_URL}`
export const FULL_MENU = `${process.env.REACT_APP_FULL_MENU}`

const MS = {
    gateway: `${HOST}/api`,
    core: `${HOST}/services/core/api`,
    profile: `${HOST}/services/profile/api`,
}

const GATEWAY = {
    authenticate: `${MS.gateway}/authenticate`,
    account: `${MS.gateway}/account`,
    registration: `${MS.gateway}/account/request-registration`,
    changePassword: `${MS.gateway}/account/change-password`,
    resetPasswordInit: `${MS.gateway}/account/reset-password/init`,
    resetPasswordFinish: `${MS.gateway}/account/reset-password/finish`,
    resetPassword: `${MS.gateway}/reset-account`,
}

const PROFILE = {
    bases: `${MS.profile}/bases`,
    userData: `${MS.profile}/user-data`,
    companies: `${MS.profile}/companies`,
    emailToDirectorate: `${MS.profile}/email-to-directorate`,
    owners:`${MS.profile}/owners`,
}

const CORE = {
    unitTypes: `${MS.core}/unit-types`,
    units: `${MS.core}/units`,
    unitByPlate: `${MS.core}/units/unit-by-plate`,
    dashboard: `${MS.core}/dashboard`,
    documentTypes: `${MS.core}/document-types`,
    documents: `${MS.core}/documents`,
    vehicles: `${MS.core}/vehicles`,
    vehiclesExcel: `${MS.core}/vehiclesExcel`,
    documentsExcel: `${MS.core}/documentsExcel`,
    documenttsVto: `${MS.core}/documentFullReport`,
    draft: `${MS.core}/tickets/draft`,
    tickets: `${MS.core}/tickets`,
    maintenances: `${MS.core}/maintenances`,
    items: `${MS.core}/items`,
    faqs: `${MS.core}/faqs`,
    checklist: `${MS.core}/check-lists`,
    includedCharges: `${MS.core}/included-charges`,
    notifications: `${MS.core}/notifications`,
    notificationsByUser: `${MS.core}/notificationsByUser`,
    invoices: `${MS.core}/invoices`,
}

export default {
    gateway: GATEWAY,
    profile: PROFILE,
    core: CORE
}
